import { render } from "./InstructorArea.vue?vue&type=template&id=754a19b0"
import script from "./InstructorArea.vue?vue&type=script&lang=js"
export * from "./InstructorArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__